import { createAppAsyncThunk } from '@/redux/create-app-thunk';

export const getBlockingMotives = createAppAsyncThunk(
  'checkout/getBlockingMotives',
  async (configKeyToRetrieve: string, { getState, rejectWithValue, extra: { checkoutService } }) => {
    try {
      const step = getState().checkout.step.label;
      const isActingAsCustomer = Object.keys(getState().admin.actAsCustomer).length > 0;

      if (step !== 'review' || !isActingAsCustomer) {
        return rejectWithValue(new Error('The current step is not review or the user is not acting as customer'));
      }
      return await checkoutService.getBlockingMotivesForShipping({ configKeyToRetrieve });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
